var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full min-h-full flex-row items-center"},[_c('div',{staticClass:"w-full min-h-full flex-row"},[_c('FormBuilder',{attrs:{"formSubmitted":"formSubmitted","isContractTerms":true,"typeOption":_vm.typeOption}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }